import React from 'react';
import { Box, SxProps, Theme } from '@mui/material';

interface ScrollStaggerProps {
  children: React.ReactNode;
  sx?: SxProps<Theme>;
}

/** Layout wrapper — no motion (cards/images stay static on scroll) */
export const ScrollStagger: React.FC<ScrollStaggerProps> = ({ children, sx }) => (
  <Box sx={sx}>{children}</Box>
);

interface ScrollStaggerItemProps {
  children?: React.ReactNode;
  sx?: SxProps<Theme>;
  component?: React.ElementType;
  href?: string;
  to?: string;
  state?: unknown;
  src?: string;
  alt?: string;
  onClick?: React.MouseEventHandler;
}

export const ScrollStaggerItem: React.FC<ScrollStaggerItemProps> = ({
  children,
  sx,
  component = 'div',
  href,
  to,
  state,
  src,
  alt,
  onClick,
}) => (
  <Box
    component={component}
    sx={sx}
    href={href}
    to={to}
    state={state}
    src={src}
    alt={alt}
    onClick={onClick}
  >
    {children}
  </Box>
);
